/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_DescriptionInputs */

const en_audit_description = /** @type {(inputs: Audit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity trail for compliance and traceability`)
};

const pt_br2_audit_description = /** @type {(inputs: Audit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trilha de atividades para conformidade e rastreabilidade`)
};

/**
* | output |
* | --- |
* | "Activity trail for compliance and traceability" |
*
* @param {Audit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_description = /** @type {((inputs?: Audit_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_description(inputs)
	return pt_br2_audit_description(inputs)
});